import React, { useEffect, useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import { DATE_URL } from '../../../../services/api/shared/noc/syslogsapi';
import TizetiLoader from "./TizetiLoaderColored.gif"
import NocNavBar from '../../../layouts/noc/NocNavBar';

const SysLogs = () => {
    const [date, setDate] = useState('')
    const [logs, setLogs] = useState([])
    const [isSearching, setIsSearching] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

  const getsyslogs = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(DATE_URL, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });

      if (response.data) {
        setLogs(response.data);
      } else {
        setLogs([]);
      }
    } catch (err) {
      setError(err);
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const searchByDate = async (searchDate) => {
  setLoading(true);
  setIsSearching(true);
  setError(null);
  try {
    const response = await axios.get(`${DATE_URL}/date?date=${searchDate}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    });
    setLogs(response.data);
  } catch (error) {
    console.error('Date search failed', error);
    setError(error);
    setLogs([]);
  } finally {
    setLoading(false);
    setIsSearching(false);
  }
};

    useEffect(() => {
        getsyslogs()
    },[])

    const onSubmit = (e) => {
    e.preventDefault();
    searchByDate(date);
  };

 const item = logs || [];

 const SysLogsLists = item ? (
      item.map((syslogs, i) => (
        <tr key={i + 1}>
          <td>{syslogs.id}</td>
          <td>{syslogs.fileName}</td>
          <td>{syslogs.created_at ? moment(syslogs.created_at).format('YYYY-MM-DD') : 'N/A'}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td>
          <p>There are no syslogs</p>
        </td>
      </tr>
    );

return (
    <div className="s-layout">
        <main className="s-layout__content col-lg-10 p-0">
            <NocNavBar currentPage="SysLogs" />
            <div className="container mt-5">
                <div className="card x-panel mt-4">
                    <form onSubmit={onSubmit} className="row align-items-end g-4 p-3">
                    <div className="col-md-3">
                        <label>Date</label>
                        <input
                        type="date"
                        className="form-control"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        />
                    </div>
                    <div className='col-md-2'>
                    <button type="submit" 
                    className="btn btn-green" 
                  
                    disabled={!date}>
                        Search
                    </button>
                    </div>
                    </form>

                    {error && (
                    <div className="alert alert-danger mx-3">Error: {error.message}</div>
                    )}

                    <div className="table-responsive content p-3">
                    <table className="table copy-font">
                        <thead>
                        <tr>
                            <th>S/N</th>
                            <th>FileName</th>
                            <th>Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        {loading || isSearching ? (
                            <tr>
                            <td colSpan="7" className="text-center">
                                <img src={TizetiLoader} alt="loader" />
                            </td>
                            </tr>
                        ) : (
                            SysLogsLists
                        )}
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </main>
    </div>
  );
}
export default SysLogs;